import { ClickAwayListener, Typography, useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { ActionsPopper } from 'Components/_common/ContentPreview/ActionsPopper/ActionsPopper'
import CustomHelmet from 'Components/_common/CustomHelmet'
import MobileMainHeader from 'Components/_common/MobileMainHeader'
import { useIsAdmin } from 'Components/Auth'
import { useEventsFinishedQuery, useEventsInProgressQuery } from 'Queries/Events'
import { useState } from 'react'
import { openGraphDescriptions } from 'Scenes/constants'
import {
  navigateToCreateContestPage,
  navigateToCreateTournamentPage,
  navigateToEventsArchivePage,
} from 'Scenes/navigators'
import Button from 'Theme/Button'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import { BREAKPOINT_MIN_SM } from 'Theme/stylesUtil'

import { EventsCardList } from './EventsCardList'
import EventsRoadmap from './EventsRoadmap'

const EventListLayout = () => {
  const isAdmin = useIsAdmin()
  const {
    data: inProgressEvents,
    isFetched: isFetchedInProgressEvents,
    hasNextPage: hasNextInProgressEventsPage,
    fetchNextPage: fetchNextInProgressEventsPage,
    isFetchingNextPage: isLoadingInProgressEvents,
  } = useEventsInProgressQuery()

  const {
    data: finishedEvents,
    isFetched: isFetchedFinishedEvents,
    hasNextPage: hasNextFinishedEventsPage,
    fetchNextPage: fetchNextFinishedEventsPage,
    isFetchingNextPage: isLoadingFinishedEvents,
  } = useEventsFinishedQuery()
  const isBiggerThanSMScreen = useMediaQuery(BREAKPOINT_MIN_SM)
  const [anchorEl, setAnchorEl] = useState(null)

  const createMenuActions = [
    {
      onClick: () => navigateToCreateContestPage(),
      showItem: true,
      title: 'Contest',
      color: 'text.tertiary',
    },
    {
      onClick: () => navigateToCreateTournamentPage(),
      showItem: true,
      title: 'Tournament',
      color: 'text.tertiary',
    },
  ]

  const handleCreateButtonClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleCreateMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <CustomHelmet
        title={'Events'}
        description={openGraphDescriptions.events}
      />
      <Box>
        <EventsRoadmap />
        <MobileMainHeader />
        <Box
          component={Container}
          py={5}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              variant="h3"
              color="text.primary"
            >
              Now in progress
            </Typography>

            {isAdmin && (
              <Box
                display="flex"
                gap="10px"
              >
                <Button
                  variant="contained"
                  color="inherit"
                  sx={(theme) => ({
                    color: theme.palette.text.secondary,
                    background: theme.palette.background.pale,
                    display: 'flex',
                    gap: theme.spacing(1),
                    padding: isBiggerThanSMScreen ? 'initial' : '8px !important',
                    minWidth: 'unset !important',
                    '&:hover': {
                      color: theme.palette.text.secondary,
                      background: theme.palette.background.pale,
                    },
                  })}
                  onClick={() => navigateToEventsArchivePage()}
                >
                  <FAIcon iconClassName={FA_ICONS.BOX_ARCHIVE_SOLID} />
                  {isBiggerThanSMScreen && 'Archive'}
                </Button>
                <ClickAwayListener onClickAway={handleCreateMenuClose}>
                  <Box sx={{ position: 'relative' }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={(theme) => ({
                        display: 'flex',
                        gap: theme.spacing(1),
                        padding: isBiggerThanSMScreen ? 'initial' : '8px !important',
                        minWidth: 'unset !important',
                      })}
                      onClick={handleCreateButtonClick}
                    >
                      <FAIcon iconClassName={FA_ICONS.PLUS} />
                      {isBiggerThanSMScreen && 'Create'}
                      <FAIcon iconClassName={FA_ICONS.CARET_DOWN} />
                    </Button>
                    <ActionsPopper
                      open={!!anchorEl}
                      anchorEl={anchorEl}
                      actions={createMenuActions}
                      minWidth="100%"
                    />
                  </Box>
                </ClickAwayListener>
              </Box>
            )}
          </Box>

          <Box
            sx={{
              marginTop: '36px',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            }}
          >
            <EventsCardList
              noContentText="No Events in Progress"
              data={inProgressEvents}
              isLoading={isLoadingInProgressEvents}
              isFetched={isFetchedInProgressEvents}
              hasNextPage={hasNextInProgressEventsPage}
              fetchNextPage={fetchNextInProgressEventsPage}
            />

            <EventsCardList
              isFinished
              title="Finished Events"
              data={finishedEvents}
              isLoading={isLoadingFinishedEvents}
              isFetched={isFetchedFinishedEvents}
              hasNextPage={hasNextFinishedEventsPage}
              fetchNextPage={fetchNextFinishedEventsPage}
            />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default EventListLayout
